import React, { ReactElement, Suspense } from 'react'
import { Header, PortalTour } from '@tecsinapse-org/portal-menu-kit'
import { ManagerProvider, SnackbarProvider } from '@tecsinapse/cortex-react'
import { Routes } from './core/router/routes'
import { ConfirmModalProvider } from './core/context/confirm-modal-context'
import { Loading } from './core/components/loading'
import { OpsErrorBoundary } from './core/components/ops-error-boundary'
import { useApp } from './core/hooks/use-app'
import { Usuario } from './core/types/graphql'

interface IApp {
  header: boolean
  manifest: string
  currentUser: Usuario
  router: ReactElement
}

export function App({ router, header, currentUser, manifest }: IApp) {
  const {
    loading,
    logout,
    countNotificacoesNaoLidas,
    loadMenuNotifications,
    changeUserLanguage,
    marcarNotificacoesComoVisualizadas,
    menuData,
    customOptions,
    menuDataProps,
    searchMode,
    setSearchMode,
    mobileSearchText,
    setMobileSearchText,
    client
  } = useApp(currentUser)

  if (!currentUser) {
    logout()
    return null
  }

  if (loading) {
    return <Loading />
  }

  return (
    <SnackbarProvider options={{ position: 'bottom-left' }}>
      <ManagerProvider>
        <ConfirmModalProvider>
          {header ? (
            <Header
              notificationCount={countNotificacoesNaoLidas ?? 0}
              notifications={loadMenuNotifications}
              breadcrumbProps={{
                apolloClient: client
              }}
              routeList={Routes}
              useReactRouter
              changeUserLanguage={changeUserLanguage}
              onCloseNotifications={async () => {
                if ((countNotificacoesNaoLidas ?? 0) > 0) {
                  await marcarNotificacoesComoVisualizadas()
                }
              }}
              logout={logout}
              currentUser={currentUser}
              {...menuData}
              customOptionsUser={customOptions}
            />
          ) : null}
          <OpsErrorBoundary>
            <div
              id='content'
              className='max-w-[1440px] w-[calc(100%-32px)] mx-auto overflow-y-scroll'
            >
              <PortalTour steps={[]}>
                <Suspense fallback={<Loading />}>
                  {React.cloneElement(router, {
                    itensMenu: menuDataProps,
                    manifest,
                    mobileSearchText,
                    setMobileSearchText,
                    searchMode,
                    setSearchMode
                  })}
                </Suspense>
              </PortalTour>
            </div>
          </OpsErrorBoundary>
        </ConfirmModalProvider>
      </ManagerProvider>
    </SnackbarProvider>
  )
}

export default App
